export const mostAndLeastUsersOtherActions = (
  key: string,
  otherActions: (key: any, params: Record<string, any>) => Promise<void>,
  data?: any
) => {

  const currentMostCompletedUser = data?.[key]?.queryParams?.mostCompletedUser || data?.[key]?.mostCompletedUser || "true";
  const mostCompletedUser = currentMostCompletedUser === "true" ? "false" : "true";
  
  return [
    {
      text: `Show ${currentMostCompletedUser === "true" ? "Least" : "Most"}`,
      action: () => {
        otherActions(key, {
          mostCompletedUser,
        });
      },
    },
  ];
}

export const ragStatusOtherActions = (
  key: string,
  otherActions: (key: any, params: Record<string, any>) => Promise<void>,
  data?: any
) => {
  // Get current RAG status from queryParams
  const queryParams = data?.[key]?.queryParams;
  const ragStatusValue = queryParams?.ragStatusRanges;
  
  // Parse current selections from query params (comma-separated string or array)
  const parseCurrentSelections = (): string[] => {
    if (!ragStatusValue || ragStatusValue === "") return [];
    if (Array.isArray(ragStatusValue)) {
      return ragStatusValue.map(v => String(v).trim()).filter(Boolean);
    }
    return String(ragStatusValue)
      .split(',')
      .map(v => v.trim())
      .filter(Boolean);
  };
  
  const currentSelections = parseCurrentSelections();
  const validRagStatuses = ['Green', 'Amber', 'Red'];
  const allSelected = validRagStatuses.every(status => currentSelections.includes(status));
  
  // Default to "All" if no selections or all are selected
  const currentRagStatus = (currentSelections.length === 0 || allSelected) ? "All" : currentSelections.join(', ');
  
  return [
    {
      text: currentRagStatus, // Show the current selected value(s)
      isDropdown: true,
      dropdownOptions: [
        { value: "all", label: "All" },
        { value: "Green", label: "Green" },
        { value: "Amber", label: "Amber" },
        { value: "Red", label: "Red" },
      ],
      currentValue: currentRagStatus,
      onSelect: (value: string) => {
        // value is a comma-separated string of selected values (excluding "all")
        // If empty string or "all" was the only selection, pass undefined
        const selectedValues = value 
          ? value.split(',').map(v => v.trim()).filter(Boolean)
          : [];
        
        // If all three statuses are selected, treat as "All" and pass undefined
        // This matches the backend logic in resolveCommonFilters
        const allThreeSelected = validRagStatuses.every(status => selectedValues.includes(status));
        
        otherActions(key, {
          ragStatusRanges: (selectedValues.length === 0 || allThreeSelected) 
            ? undefined 
            : selectedValues.join(','), // Pass comma-separated string to match backend expectation
        });
      },
    },
  ];
}
